// extracted by mini-css-extract-plugin
export default {"badge":"info-badge_badge__vcJkc","messageAndIcon":"info-badge_messageAndIcon__VZgTW","buttonContainer":"info-badge_buttonContainer__+hsHC"};